import React from 'react';
import { useQuery } from 'react-query';
import { RefreshCw } from 'lucide-react';
import { getDashboardDiagnostics } from '../services/investmentService';

const Audit: React.FC = () => {
  const { data, isLoading, error, refetch, isFetching } = useQuery(
    ['dashboard-diagnostics'],
    getDashboardDiagnostics,
    {
      refetchOnWindowFocus: false,
      staleTime: 30000,
    }
  );

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-start">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Auditoria</h1>
          <p className="text-gray-600">Estado do processamento automático, cache e API de mercado</p>
        </div>
        <button
          onClick={() => refetch()}
          className="flex items-center px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
        >
          <RefreshCw className={`h-4 w-4 mr-2 ${isFetching ? 'animate-spin' : ''}`} />
          Atualizar
        </button>
      </div>

      {isLoading && (
        <div className="card">
          <div className="flex items-center justify-center h-24">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
          </div>
        </div>
      )}

      {Boolean(error) && (
        <div className="card">
          <p className="text-danger-600">Erro ao carregar dados de auditoria.</p>
        </div>
      )}

      {Boolean(data) && data && (
        <>
          <div className="card space-y-2">
            <h2 className="text-lg font-semibold text-gray-900">Investimento Automático</h2>
            <p><span className="font-medium">Último processamento:</span> {data.automatic_investments.last_processed_date ?? 'N/A'}</p>
            <p>
              <span className="font-medium">Processado hoje:</span>{' '}
              <span className={data.automatic_investments.processed_today ? 'text-green-600' : 'text-yellow-600'}>
                {data.automatic_investments.processed_today ? 'Sim' : 'Não'}
              </span>
            </p>
            <p><span className="font-medium">N.º processamentos hoje:</span> {data.automatic_investments.processed_today_count}</p>
          </div>

          <div className="card space-y-2">
            <h2 className="text-lg font-semibold text-gray-900">Cache</h2>
            <p><span className="font-medium">TTL:</span> {data.cache.ttl_hours}h ({data.cache.ttl_seconds}s)</p>
            <p><span className="font-medium">Última invalidação:</span> {data.cache.last_invalidation_at ?? 'N/A'}</p>
            <p><span className="font-medium">Ficheiros ativos:</span> {data.cache.active_cache_files}</p>
          </div>

          <div className="card space-y-2">
            <h2 className="text-lg font-semibold text-gray-900">API de Mercado</h2>
            <p>
              <span className="font-medium">Estado:</span>{' '}
              <span className={data.market_data_api.is_reachable ? 'text-green-600' : 'text-danger-600'}>
                {data.market_data_api.is_reachable ? 'Operacional' : 'Com falhas'}
              </span>
            </p>
            <p><span className="font-medium">Configurada:</span> {data.market_data_api.configured ? 'Sim' : 'Não'}</p>
            <p><span className="font-medium">URL efetiva:</span> {data.market_data_api.effective_url}</p>
            {data.market_data_api.error && (
              <p className="text-danger-600"><span className="font-medium">Erro:</span> {data.market_data_api.error}</p>
            )}
          </div>

          <div className="text-sm text-gray-500">
            Hora do servidor: {new Date(data.server_time).toLocaleString('pt-PT')}
          </div>
        </>
      )}
    </div>
  );
};

export default Audit;
